/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Termodinamica() {
  return (
    <PaginasEspecificas posicao="10" endereco="/fisica" materia="Física" />
  );
}

export default Termodinamica;
